/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { product_article } from '../models/product_article';
import type { vw_product_article } from '../models/vw_product_article';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductArticleService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postProductArticleDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product_article/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of product articles
     * @returns vw_product_article A list of product article
     * @throws ApiError
     */
    public getProductArticles(): CancelablePromise<Array<vw_product_article>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/product_articles',
        });
    }

    /**
     * Get product article by id
     * @returns vw_product_article The product article data
     * @throws ApiError
     */
    public getProductArticle({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_product_article> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/product_article/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `ProductArticle not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a product_article by id
     * @returns any Product Article deleted successfully
     * @throws ApiError
     */
    public deleteProductArticle({
        id,
    }: {
        /**
         * The product_article id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/product_article/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Product Article not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Product Article
     * @returns any Product Article created successfully
     * @throws ApiError
     */
    public postProductArticle({
        requestBody,
    }: {
        requestBody: product_article,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product_article',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing ProductArticle
     * @returns any Product Article updated successfully
     * @throws ApiError
     */
    public putProductArticle({
        requestBody,
    }: {
        requestBody: product_article,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/product_article',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `ProductArticle not found`,
                500: `Internal server error`,
            },
        });
    }

}
